export default {
    HEADER: 'Terminal',
    PLACEHOLDER_NAME: 'Unesite naziv terminala',
    LABEL_NAME: 'Naziv terminala',
    PLACEHOLDER_EMAIL: 'Unesite email adresu',
    LABEL_EMAIL: 'Email',
    PLACEHOLDER_PASSWORD: 'Unesite lozinku',
    LABEL_PASSWORD: 'Lozinka',
    LABEL_NEW_PASSWORD: 'Nova lozinka',
    PLACEHOLDER_NEW_PASSWORD: 'Unesite novu lozinku',
    PLACEHOLDER_DESCRIPTION: 'Unesite opis',
    LABEL_DESCRIPTION: 'Opis',
    LABEL_STATUS: 'Status',
    LABEL_DEVICE_TYPE: 'Tip uređaja',
    DEVICE_TYPE_TABLET: 'TABLET',
    DEVICE_TYPE_PHONE: 'TELEFON',
    PLACEHOLDER_DEVICE_ID: 'Unesite id uređaja',
    LABEL_DEVICE_ID: 'Id uređaja',
    LABEL_ACCOUNT_ID: 'Nalog',
    SAVE_BUTTON: 'Sačuvaj',
    CANCEL_BUTTON: 'Poništi',
};
